import SvgSelector from '@/components/Svg/SvgSelector';
import { INQUIRY } from '@/models/plan';
import { SelectedIns } from '@/recoil/plan';
import { FontStyle } from '@/utils/StyleUtil';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import styled, { css } from 'styled-components';

export default function FloatingMenu() {
    const router = useRouter();
    const setInsuranceType = useSetRecoilState(SelectedIns);
    const [expanded, isExpanded] = useState(() => {
        const value = sessionStorage.getItem('floating-menu-inquiry');
        if (value === null) return true;
        return value === 'true';
    });

    useEffect(() => {
        sessionStorage.setItem('floating-menu-inquiry', expanded ? 'true' : 'false');
    }, [expanded]);

    return expanded ? (
        <Expanded
            type="button"
            onClick={() => {
                setInsuranceType(INQUIRY);
                router.push('/ask/user-info');
            }}
        >
            <SvgWrapper
                type="button"
                onClick={e => {
                    e.stopPropagation();
                    isExpanded(false);
                }}
            >
                <SvgSelector svg="close" width="16" height="16" stroke="#ffffff" />
            </SvgWrapper>
            빠른 상담을 원한다면?
            <ImageWrapper>
                <Image
                    src="/img/character/floating_dog_expanded.png"
                    alt="floating_dog_expanded"
                    width="62"
                    height="65"
                />
            </ImageWrapper>
        </Expanded>
    ) : (
        <Folded
            type="button"
            onClick={() => {
                setInsuranceType(INQUIRY);
                router.push('/ask/user-info');
            }}
        >
            상담문의
            <ImageFWrapper>
                <Image src="/img/character/floating_dog.png" alt="floating_dog" width="56" height="52" />
            </ImageFWrapper>
        </Folded>
    );
}

const Pos = css`
    position: fixed;
    right: 20px;
    bottom: calc(57px + 20px);
    @media (min-width: 1280px) {
        right: calc(50% - 230px);
    }
`;

const Expanded = styled.button`
    ${Pos};
    width: 263px;
    padding: 16px;
    display: flex;
    align-items: center;
    border-radius: 80px;
    background: linear-gradient(90deg, #2dc5cf 18.78%, #0089b5 106.44%);
    box-shadow: 4px 4px 12px 0 rgba(0, 0, 0, 0.12);
    ${FontStyle(16, 24, '500', '#ffffff', -1)};
`;

const SvgWrapper = styled.button`
    opacity: 0.8;
    font-size: 0;
    padding: 4px 8px 4px 0;
`;

const ImageWrapper = styled.div`
    position: absolute;
    bottom: -12px;
    right: 16px;
    font-size: 0;
`;

const Folded = styled.button`
    ${Pos};
    height: 98px;
    padding: 12px 6px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    border-radius: 32px;
    background: linear-gradient(180deg, #2dc5cf -9.5%, #0089b5 171.5%);
    box-shadow: 4px 4px 12px 0 rgba(0, 0, 0, 0.12);
    ${FontStyle(14, 22, '500', '#ffffff', -1)};
`;

const ImageFWrapper = styled.div`
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    font-size: 0;
`;
